import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { Dropdown } from '../../../legacy-design-system/dropdown'
import { FormattedMessage } from 'react-intl'

function AngularDropdown(props) {
  return (
    <Dropdown
      {...props}
      menuFooterRenderer={
        !!props.menuFooterMessage &&
        (() => {
          return <FormattedMessage {...props.menuFooterMessage} />
        })
      }
    />
  )
}

export const reactDropdown = createNgReactBridgeDirective(
  'reactDropdown',
  [],
  AngularDropdown,
  [
    'items',
    'selectedItem',
    'itemToString',
    'itemToKey',
    'onChange',
    'menuFooterMessage'
  ]
)
